import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import "./footer.css";
import ScrollToTop from "react-scroll-to-top";

const Footer = () => {
  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };

  return (
    <footer>
      <ScrollToTop
        smooth
        top="600"
        color="#4db5ff"
        width="28"
        height="21"
        style={{
          background: "#2c2c6c",
          borderRadius: "1rem",
          marginBottom: "68px",
          right: "15px",
          height: "40px",
          width: "35px",
        }}
      />
      <a href="#home" className="footer__logo">
        AMARTYA KUMAR
      </a>
      <ul className="permalinks">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Skills</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#education">Education</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/amartya324/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        <a
          href="https://github.com/amartya324"
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub />
        </a>
        <a
          href="https://www.instagram.com/amartya324/"
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram />
        </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; amartya324 {getYear()}. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
